import React from "react";
import "./SchoolFalse.css";

function SchoolFalse(props) {
  const { sohniJunejaSchoolOfMakeup, line17 } = props;

  return (
    <div className="accordian-5-1">
      <div className="frame-36">
        <div className="overlap-group-4">
          <div className="frame-37">
            <p className="sohni-juneja-school-of-makeup poppins-medium-tundora-16px">{sohniJunejaSchoolOfMakeup}</p>
            <img className="line-17" src={line17} />
          </div>
          <img className="vector-3" src="/img/vector-2@2x.png" />
        </div>
      </div>
    </div>
  );
}

export default SchoolFalse;
